import { lazy } from "react";

export interface IProps {
  onClose?: () => void;
}

export const LazyMobileMenu = lazy(() =>
  import(
    /* webpackChunkName: "retailer-mobile-menu" */ "@faire/deprecated-retailer-visitor-shared/components/Header/mobile/MobileMenu/MobileMenu"
  ).then((m) => ({ default: m.MobileMenu }))
);
